import { render, staticRenderFns } from "./PantsCertificationBadges.vue?vue&type=template&id=7f1654d6&scoped=true"
import script from "./PantsCertificationBadges.vue?vue&type=script&lang=js"
export * from "./PantsCertificationBadges.vue?vue&type=script&lang=js"
import style0 from "./PantsCertificationBadges.vue?vue&type=style&index=0&id=7f1654d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1654d6",
  null
  
)

export default component.exports